import { Hero, HomeBar, Features, Tokenomics, RoadMap, Team, Footer } from "../component";
import { useEffect, useRef, useState, } from "react";

const Home = () => {
    const [offSetY, setOffSetY] = useState(0);
    const [loadSet, setLoadSet] = useState(false);
    const handleScrolling = () => {
        if (!mainDiv.current.scrollTop) return;
        setOffSetY(mainDiv.current.scrollTop);
    }
    const mainDiv = useRef();


    useEffect(() => {
        if (!mainDiv.current) return;
        mainDiv.current.addEventListener('scroll', handleScrolling);
        setLoadSet(true);

        return () => mainDiv.current.removeEventListener('scroll', handleScrolling);
    }, []);

    useEffect(() => {
        if (!loadSet) return;
        if (window.location.href.includes('#')) {
            let target = window.location.href.split('#')[1];
            if (target.length) {
                let ntarget = document.querySelector(`#${target.replace(target.charAt(0), target.charAt(0).toUpperCase())}`);
                ntarget.scrollIntoView({behavior: "smooth"});
            }
        }
    }, [loadSet]);

    const handleScroll = (e) => {
        let target_id = e.target.getAttribute('data-target');
        let target = document.querySelector(`#${target_id}`);
        target.scrollIntoView({behavior: "smooth"});
    }

    return (
        <div className="ladscatch__container" ref={(e) => mainDiv.current=e}>
            <HomeBar onScroll={(e) => handleScroll(e)} scrollY={offSetY} />
            <Hero />
            <Features pageOffset={offSetY} />
            <RoadMap />
            <Tokenomics />
            <Team pageOffset={offSetY} />
            <Footer />
        </div>
    )
}

export default Home;